import { Icon, IconButton, useColorModeValue } from "@chakra-ui/react";
import React, { useContext } from "react";
import { FaGraduationCap } from "react-icons/fa";
import { MapContext } from "../context/map.context";

const CampusButton = () => {
  const { reset } = useContext(MapContext);
  const background = useColorModeValue("gray.200", "gray.900");

  return (
    <IconButton
      bg={background}
      _hover={{ bg: background, filter: "brightness(1.2)" }}
      _active={{ bg: background, filter: "brightness(1)" }}
      boxShadow="md"
      aria-label="Go to campus"
      icon={<Icon as={FaGraduationCap} />}
      onClick={reset}
    />
  );
};

export default CampusButton;
